import React from 'react';
import { useLocation } from 'react-router-dom';
import { FaYoutube } from 'react-icons/fa'
import { FaTwitter } from 'react-icons/fa'
import { FaFacebook } from 'react-icons/fa'
import { FaInstagram } from 'react-icons/fa'

const SocialShare = () => {
  const location = useLocation();
  const currentUrl = window.location.origin + location.pathname;
  const encodedUrl = encodeURIComponent(currentUrl);

  const shareLinks = {
    youtube: `https://www.youtube.com/watch?v=${encodedUrl}`,
    twitter: `https://twitter.com/intent/tweet?url=${encodedUrl}`,
    facebook: `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`,
    instagram: `https://www.instagram.com/?url=${encodedUrl}`,
  };

  const handleShare = (platform) => {
    const shareUrl = shareLinks[platform];
    window.open(shareUrl, '_blank', 'width=600,height=400');
  };

  return (
    <div className="social-share">
      <span className="share-text">Paylaş:</span>
      <div className="share-buttons">
        <button 
          onClick={() => handleShare('youtube')} 
          className="share-button youtube"
          title="YouTube'da Paylaş"
        >
          <FaYoutube size={17} />
        </button>
        <button 
          onClick={() => handleShare('twitter')} 
          className="share-button twitter"
          title="Twitter'da Paylaş"
        >
          <FaTwitter size={17} />
        </button>
        <button 
          onClick={() => handleShare('facebook')} 
          className="share-button facebook"
          title="Facebook'ta Paylaş"
        >
          <FaFacebook size={17} />
        </button>
        <button 
          onClick={() => handleShare('instagram')} 
          className="share-button instagram"
          title="Instagram'da Paylaş"
        >
          <FaInstagram size={17} />
        </button>
      </div>
    </div>
  );
};

export default SocialShare;
